import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { TruncateModule } from '@yellowspot/ng-truncate';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { NgPipesModule } from 'ngx-pipes';
import { ToolsModule } from '../../../tools/src/lib/tools.module';
import { AppComponent } from './app.component';
import { ManageGroupsComponent } from './manage-groups/manage-groups.component';
import { ClassGroupComponent } from './forms/classGroup/ctl.school.classgroup.component';
import { ManagegroupsPipe } from './manage-groups/managegroups.pipe';

@NgModule({
  declarations: [
    AppComponent,
    ManageGroupsComponent,
    ClassGroupComponent,
    ManagegroupsPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SelectDropDownModule,
    NgPipesModule,
    TruncateModule,
    ToolsModule,
    TranslateModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent],
  exports: [SelectDropDownModule, NgPipesModule, CommonModule]
})
export class AppModule { }

@NgModule({})
export class ClassroomSharedModule{
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AppModule,
      providers: []
    };
  }
}
